// Version générée automatiquement au build
export const VERSION = {
  number: '0.1.00', // ← Tu incrémentes manuellement à chaque déploiement
  buildDate: new Date().toLocaleString('fr-FR'),
};
